import React, { Component } from "react"
import { BrowserRouter as Router } from "react-router-dom"
import axios from "axios"

// Components Folder
import Registration from "./components/Registration"
import NavBar from "./components/NavBar"
import Completed from "./components/Completed"
import Question from "./components/Question"
import Footer from "./components/Footer"

// Extra styles & settings
import "./config"
import "./style.css"

class Game extends Component {
  constructor(props) {
    super(props)

    this.state = {
      dark: false,
      user: {
        id: null,
        name: "player",
        score: 0,
        correct: 0,
        registered: false,
        answered: false,
      },
      game: {
        questions: null,
        loading: true,
        error: false,
        count: 0,
        numQuestions: 20,
        difficulty: "medium",
        multiplier: 1,
      },
      leaderboard: {
        topFive: [],
        loaded: false,
      },
    }

    // Clear database of all entries < 3 points
    axios(global.config.base + "clear")
  }

  // Get the top 5 users from the database upon Mount
  componentDidMount() {
    this.updateLeaderboard()
  }

  handleStateChange = (value) => {
    this.setState(value)
  }

  handleColorSwitch = () => {
    this.setState({ dark: !this.state.dark })
    document.body.classList.toggle("bg-dark", !this.state.dark)
  }

  render() {
    var loadMoreQuestions = this.state.game.count < this.state.game.numQuestions

    return (
      <Router>
        <NavBar {...this.state.user} />
        <main className="container">
          {/* If the user is not registered, show registration */}
          {!this.state.user.registered && (
            <Registration
              {...this.state}
              handleStateChange={this.handleStateChange}
            />
          )}

          {/* If the user is registered, but game is loading, show loading screen */}
          {this.state.game.loading && this.state.user.registered && (
            <main className="container">
              <section className="jumbotron">
                <h3>Loading...</h3>
              </section>
            </main>
          )}

          {/* If there was an error loading questions, show a message */}
          {this.state.game.error && (
            <h1>There was an error loading the questions. Please try again.</h1>
          )}

          {/* If the user is registered, and we need to load more questions, show question */}
          {this.state.game.questions && loadMoreQuestions && (
            <Question
              {...this.state}
              handleStateChange={this.handleStateChange}
              handleGameEnd={this.gameOver}
            />
          )}

          {/* If the user has completed their set of questions show their score */}
          {!loadMoreQuestions && <Completed {...this.state} />}
        </main>
        <Footer switchColor={this.handleColorSwitch} />
      </Router>
    )
  }

  // Function to handle game end
  gameOver = () => {
    axios
      .post(global.config.base + "update/" + this.state.user.id, {
        score: this.state.user.score,
        multiplier: this.state.game.multiplier,
      })
      .then(() => {
        this.updateLeaderboard()
      })
      .catch((err) => {
        console.log(err)
      })
  }

  // Function to fetch top leaderboard from API & update state
  updateLeaderboard() {
    axios
      .get(global.config.base + "top")
      .then((res) => {
        this.setState(() => ({
          leaderboard: {
            topFive: res.data,
            loaded: true,
          },
        }))
      })
      .catch((err) => {
        this.setState(() => ({
          leaderboard: {
            topFive: null,
            loaded: true,
          },
        }))
        console.log(err)
      })
  }
}

export default Game
